<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="detailPlanningForm" id="detailPlanningForm" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>Detail Planning</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="BackToOutlet" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                </v-toolbar>
                
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                        <v-col lg="2" md="3" sm="8" cols="4">
                            <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                </template>
                                <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">Outlet</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <span v-else>{{ outlet.code }} - {{ outlet.name }}</span>
                        </v-col>
                        <v-col cols="2">Delivery Schedule</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <span v-else>
                                {{ deliverySchedulesLabel }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                        <v-col lg="2" md="3" sm="8" cols="4">
                            <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                                </template>
                                <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">Variant Bottle / Volume</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <span v-else>
                                <v-select outlined dense hide-details="auto" class="compact-form" :items="filteredBotols" item-value="code" item-text="description" return-object v-model="selectedBottle" @change="onChangeBottle" />
                            </span>
                        </v-col>
                        <v-col cols="3">
                            <v-btn depressed color="primary" @click="refreshData" class="me-2">Refresh</v-btn>
                            <v-btn depressed color="primary" @click="clickCalculateColumn" class="">
                                <span v-if="!isShowSquareCol">Show Calculate Column</span>
                                <span v-else>Hide Calculate Column</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <section class="view pt-0">
                        <v-card class="table-container" style="max-height: 440px;">
                            <v-simple-table dense class="no-padding-table pt-5 flex-table freeze-column-table" fixed-header>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>
                                                <v-skeleton-loader type="text" v-if="isLoading" />
                                                <span v-else>
                                                {{ selectedBottle.description }}
                                                </span>
                                            </th>
                                            <th>SISA KEMARIN</th>
                                            <th>STOCK IN</th>
                                            <!-- <th v-if="outlet.is_inner_city">STOCK IN POLIM</th> -->
                                            <th>STOCK IN CIKUPA</th>
                                            <th>TRANSFER IN</th>
                                            <th>TRANSFER OUT</th>
                                            <th>TOTAL</th>
                                            <th>PLANNING JUAL (ACTUAL)</th>
                                            <th>SISA</th>
                                            <th>MIN</th>
                                            <th>MAX</th>
                                            <th v-if="outlet.is_inner_city">TARGET JUAL TOTAL</th>
                                            <th v-if="!outlet.is_inner_city">STATUS BOTOL</th>
                                            <th>TARGET JUAL</th>
                                            <th>RETUR</th>
                                            <th>JUAL BESOK TERAKHIR</th>
                                            <th>HATI2</th>
                                            <th v-if="!outlet.is_inner_city">JUAL HARI INI</th>
                                            <th v-if="outlet.is_inner_city">BARU DATANG</th>
                                            <th>BARANG BEKU</th>
                                            <th v-if="!outlet.is_inner_city">BARANG BEKU H-1</th>
                                            <th v-if="!outlet.is_inner_city">BARANG BEKU KHUSUS SABTU</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="isLoading">
                                            <tr v-for="n in 15" :key="n">
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <!-- <td v-if="outlet.is_inner_city"><v-skeleton-loader type="text" /></td> -->
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td v-if="outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                                <td v-if="!outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td v-if="!outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                                <td v-if="outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td v-if="!outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                                <td v-if="!outlet.is_inner_city"><v-skeleton-loader type="text" /></td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-for="(row, idx) in items" :key="idx">
                                                <th class="text-no-wrap">
                                                    <span :class="{'red--text': row.is_holiday }">
                                                        {{ row.day_name }}
                                                        {{ row.sales_date_format }}
                                                    </span>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs}">
                                                            <div v-bind="attrs" v-on="on" style="display: inline-block;">
                                                                <v-btn class="mx-2" x-small dense text icon color="blue lighten-2"
                                                                    @click="handleShowNote(row)"
                                                                    >
                                                                    <v-badge color="red" :value="row.notes" bordered top dot offset-x="20" offset-y="7">
                                                                        <v-icon>mdi-note-multiple-outline</v-icon>
                                                                    </v-badge>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <span>{{ row.notes }}</span>
                                                    </v-tooltip>
                                                </th>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_opening_${idx}`"
                                                            :key="`sqi_opening_${idx}`"
                                                            :value="calculateOpening(row, idx)"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field :value="calculateOpening(row, idx)" readonly filled class="compact-form custom-center-input pb-2" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_stock_in_${idx}`"
                                                            :key="`sqi_stock_in_${idx}`"
                                                            :value="row.stock_in"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.stock_in" :readonly="isDisableInputStockIn(row)" :filled="isDisableInputStockIn(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInputStockIn(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <!-- <td v-if="outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_stock_in_polim_${idx}`"
                                                            :key="`sqi_stock_in_polim_${idx}`"
                                                            :value="row.stock_in_polim"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.stock_in_polim" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td> -->
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_stock_in_cikupa_${idx}`"
                                                            :key="`sqi_stock_in_cikupa_${idx}`"
                                                            :value="row.stock_in_cikupa"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.stock_in_cikupa" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_transfer_in_${idx}`"
                                                            :key="`sqi_transfer_in_${idx}`"
                                                            :value="row.transfer_in"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.transfer_in" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_transfer_out_${idx}`"
                                                            :key="`sqi_transfer_out_${idx}`"
                                                            :value="row.transfer_out"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.transfer_out" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td style="min-width: 80px;">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_total_${idx}`"
                                                            :key="`sqi_total_${idx}`"
                                                            :value="calculateTotal(row, idx)"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field :value="calculateTotal(row, idx)" readonly filled class="compact-form custom-center-input pb-2" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_sales_planning_${idx}`"
                                                            :key="`sqi_sales_planning_${idx}`"
                                                            :value="row.sales_planning"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.sales_planning" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" 
                                                            :class="{'text-input': !isDisableInput(row), 'red-input': row.min_stock == 0 && row.max_stock == 0 }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td style="min-width: 80px;">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_closing_${idx}`"
                                                            :key="`sqi_closing_${idx}`"
                                                            :value="calculateClosing(row, idx)"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field :value="calculateClosing(row, idx)" readonly filled class="compact-form custom-center-input pb-2" :class="{'warning-input': isWarning(row, idx) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td style="min-width: 80px;">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_min_${idx}`"
                                                            :key="`sqi_min_${idx}`"
                                                            :value="row.min_stock"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.min_stock" readonly filled class="compact-form custom-center-input pb-2" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td style="min-width: 80px;">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_max_stock_${idx}`"
                                                            :key="`sqi_max_stock_${idx}`"
                                                            :value="row.max_stock"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.max_stock" readonly filled class="compact-form custom-center-input pb-2" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_sales_target_total_${idx}`"
                                                            :key="`sqi_sales_target_total_${idx}`"
                                                            :value="calculateSalesTargetTotal(row, items)"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field :value="calculateSalesTargetTotal(row, items)" class="compact-form custom-center-input pb-2" readonly filled type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="!outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_status_botol_${idx}`"
                                                            :key="`sqi_status_botol_${idx}`"
                                                            :value="calculateStatusBotol(row, items, idx)"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field :value="calculateStatusBotol(row, items, idx)" class="compact-form custom-center-input pb-2" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_sales_target_${idx}`"
                                                            :key="`sqi_sales_target_${idx}`"
                                                            :value="row.sales_target"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field 
                                                            :value="row.sales_target"
                                                            @input="updateSalesTarget(row, $event)"
                                                            :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td style="min-width: 80px;">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_return_${idx}`"
                                                            :key="`sqi_return_${idx}`"
                                                            :value="row.return"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.return" :readonly="isDisableInput(row)" :filled="isDisableInput(row)" class="compact-form custom-center-input pb-2" :class="{'text-input': !isDisableInput(row) }" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_sales_tomorrow_${idx}`"
                                                            :key="`sqi_sales_tomorrow_${idx}`"
                                                            :value="row.sales_tomorrow"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.sales_tomorrow" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_cautions_${idx}`"
                                                            :key="`sqi_cautions_${idx}`"
                                                            :value="row.cautions"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.cautions" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="!outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_sales_today_${idx}`"
                                                            :key="`sqi_sales_today_${idx}`"
                                                            :value="row.sales_today"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.sales_today" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_new_arrival_${idx}`"
                                                            :key="`sqi_new_arrival_${idx}`"
                                                            :value="row.new_arrival"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.new_arrival" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_frozen_${idx}`"
                                                            :key="`sqi_frozen_${idx}`"
                                                            :value="row.frozen"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.frozen" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="!outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_frozen_h1_${idx}`"
                                                            :key="`sqi_frozen_h1_${idx}`"
                                                            :value="row.frozen_h1"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.frozen_h1" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                                <td v-if="!outlet.is_inner_city">
                                                    <div class="d-flex flex-row">
                                                        <SquareItem v-show="isShowSquareCol"
                                                            :id="`sqi_frozen_saturday_${idx}`"
                                                            :key="`sqi_frozen_saturday_${idx}`"
                                                            :value="row.frozen_saturday"
                                                            :selectedItems="selectedSquareItems"
                                                            @toggle="toggleItem"
                                                        />
                                                        <v-text-field v-model="row.frozen_saturday" class="compact-form custom-center-input pb-2 blue-light-input" type="number" dense outlined hide-details @wheel="$event.target.blur()" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </section>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                            <tr>
                                <th class="text-end py-2">
                                    <span class="px-3">Average : {{ calculateAvgSelectedSquareItem }}</span> | 
                                    <span class="px-3">Count : {{ calculateCountSelectedSquareItem }}</span> | 
                                    <span class="px-3">Sum : {{ calculateSumSelectedSquareItem }}</span>
                                    <span class="px-2"></span>
                                </th>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>

                    <v-row class="mx-5">
                        <v-col>
                            <LegendColor />
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveDetailPlanning" :disabled="!canUpdate">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form> 
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row justify="center">
            <v-dialog v-model="dialogNote" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Catatan {{ noteTitle }}</span>
                    </v-card-title>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-textarea v-model="updatedNote" solo label="Masukkan catatan..." />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" @click="saveNote">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog v-model="showDialog" max-width="400px">
        <v-card>
            <v-card-title class="headline">Success</v-card-title>
            <v-card-text>
                Your data has been saved successfully.
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showDialog = false">OK</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>        
        
    </div>
</template>

<script>
import moment from 'moment';
import SquareItem from '@/components/SquareItem';
import LegendColor from '@/components/LegendColor.vue';

export default {
    components: {
        SquareItem,
        LegendColor,
    },
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            isLoadingOutlet: false,
            isLoading: false,
            saveProgress: false,
            save: false,
            saveError: false,
            reqRule: [v => !!v || 'Harus diisi!'],
            valid: true,
            dateMenu: false,
            date: null,
            bottle: {},
            items: [],
            delivery_schedules: [
                { key: 1, value: 'Minggu' },
                { key: 2, value: 'Senin' },
                { key: 3, value: 'Selasa' },
                { key: 4, value: 'Rabu' },
                { key: 5, value: 'Kamis' },
                { key: 6, value: 'Jumat' },
                { key: 7, value: 'Sabtu' },
            ],
            numberRule: val => {
                if (val < 0) return 'Tidak boleh kurang dari 0'
                return true
            },
            outlet: {},
            selectedBottle: null,
            botols: [],
            filteredBotols: [],
            dialogNote: false,
            noteTitle: '',
            updatedNote: '',
            noteIndex: '',
            isShowSquareCol: false,
            selectedSquareItems: [],
            selectedSquareType: 'sum',
            showDialog: false,
        }
    },

    async created() {
        this.getBotols();

        this.date = moment().format('YYYY-MM-DD');

        this.fetchOutlet();
    },

    async mounted() {
        if (this.$route.params.action == 'edit') {
            this.updateStatusOutlet('in_progress');
        }

        this.selectedBottle = this.filteredBotols.find(b => b.code === '490') || null;

        history.pushState(null, null, window.location.href);
        window.addEventListener("popstate", this.handleBackButton);
    },
    beforeUnmount() {
        window.removeEventListener("popstate", this.handleBackButton);
    },

    computed: {
        deliverySchedulesLabel() {
            if (!this.isObjectEmpty(this.outlet)) {
                return this.delivery_schedules
                    .filter(schedule => this.outlet.delivery_schedules.includes(schedule.key))
                    .map(schedule => schedule.value)
                    .join(', ')

            } else {
                return ''
            }
        },
        profile () {
            return this.$store.state.profile
        },
        canUpdate() {
            if (this.$route.params.action != 'edit') {
                return false;
            }

            if (this.outlet.detail_planning_status === 'open') {
                if (this.$route.params.action == 'edit')
                    return true;
                else
                    return false;
            } else {
                return this.outlet.detail_planning_status === 'in_progress' && this.profile.username === this.outlet.detail_planning_user;
            }
        },
        calculateSumSelectedSquareItem() {
            return this.selectedSquareItems.reduce((sum, item) => sum + Number(item.value), 0);
        },
        calculateCountSelectedSquareItem() {
            return this.selectedSquareItems.length;
        },
        calculateAvgSelectedSquareItem() {
            const sum = this.selectedSquareItems.reduce((sum, item) => sum + Number(item.value), 0);
            if (this.selectedSquareItems.length === 0) {
                return 0;
            }
            return sum / this.selectedSquareItems.length;
        },
    },

    methods: {
        isObjectEmpty(obj) {
            return Object.keys(obj).length === 0
        },
        getBotols() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.botols = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });

            this.bottle = this.botols.slice(0, 1)[0];
        },
        setDate() {
            this.fetchDetailPlanning();
        },
        onChangeBottle() {
            this.fetchDetailPlanning();
        },
        handelChangeStartDate() {
            this.fetchDetailPlanning();
        },
        handelChangeEndDate() {
            this.fetchDetailPlanning();
        },
        filterBotols() {
            if (this.outlet.botols.length === 0) {
                this.filteredBotols = this.botols
            } else {
                this.filteredBotols = this.botols.filter(item => this.outlet.botols.includes(item.code))
            }

            this.selectedBottle = this.filteredBotols.find(b => b.code === '490') || null;
        },
        async fetchOutlet() {
            this.isLoadingOutlet = true;
            const outletCode = this.$route.params.outlet_code;

            try {
                const data = (await this.$store.dispatch('outlet/getObj', outletCode));
                this.outlet = data;
                this.selectedBotol = this.outlet.botols;
                this.filterBotols();

                this.fetchDetailPlanning();
            } catch (error) {
                console.error('Error fetching outlet:', error);
            } finally {
                this.isLoadingOutlet = false;
            }  
        },
        /**
         * Fetch detail planning data and integrate with closing outlet data
         * This ensures that closing outlet fields (sales_tomorrow, cautions, etc.)
         * are loaded and synchronized with detail planning
         */
        async fetchDetailPlanning() {
            this.isLoading = true;
            const outletCode = this.$route.params.outlet_code

            try {
                // Fetch detail planning data
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `detail-plannings`,
                    parameter: `?outlet=${outletCode}&size=${this.selectedBottle.code}&start_date=${this.start_date}&end_date=${this.end_date}`,
                }));

                const data = response.data.data;

                this.items = data.items;
                this.start_date = data.start_date;
                this.end_date = data.end_date;

                // Fetch and integrate closing outlet data
                // This will merge closing outlet data (sales_tomorrow, cautions, etc.) 
                // into detail planning items based on date and volume
                await this.integrateClosingOutletData(outletCode);
            } catch (error) {
                console.error('Error fetching detail planning:', error);
            } finally {
                this.isLoading = false;
            }  
        },
        /**
         * Integrate closing outlet data into detail planning items
         * This method fetches closing outlet data and merges it into detail planning items
         * Fields integrated: sales_tomorrow, cautions, new_arrival, frozen, 
         *                    sales_today, frozen_h1, frozen_saturday (for outer city)
         */
        async integrateClosingOutletData(outletCode) {
            try {
                // Fetch closing outlet data for the same period and volume
                const closingResponse = await this.$store.dispatch('outletclosing/getObjs', {
                    apidomain: 'outlet-closings',
                    parameter: `?outlet_code=${outletCode}&volume=${this.selectedBottle.code}&start_date=${this.start_date}&end_date=${this.end_date}`
                });

                if (closingResponse.data.status === 'success' && closingResponse.data.data) {
                    const closingData = closingResponse.data.data;
                    
                    // Create a map of closing data by date for quick lookup
                    const closingMap = {};
                    closingData.forEach(closing => {
                        const dateKey = moment(closing.closing_date).format('YYYY-MM-DD');
                        closingMap[dateKey] = closing;
                    });

                    // Merge closing outlet data into items
                    this.items.forEach((item, index) => {
                        const itemDate = moment(item.sales_date).format('YYYY-MM-DD');
                        const closingItem = closingMap[itemDate];

                        if (closingItem) {
                            // Update fields with closing outlet data
                            this.$set(this.items[index], 'sales_tomorrow', closingItem.sales_tomorrow || 0);
                            this.$set(this.items[index], 'cautions', closingItem.cautions || 0);
                            this.$set(this.items[index], 'new_arrival', closingItem.new_arrival || 0);
                            this.$set(this.items[index], 'frozen', closingItem.frozen || 0);
                            
                            // For outer city outlets
                            if (!this.outlet.is_inner_city) {
                                this.$set(this.items[index], 'sales_today', closingItem.sales_today || 0);
                                this.$set(this.items[index], 'frozen_h1', closingItem.frozen_h1 || 0);
                                this.$set(this.items[index], 'frozen_saturday', closingItem.frozen_saturday || 0);
                            } else {
                                // For inner city, ensure these fields are 0
                                this.$set(this.items[index], 'sales_today', 0);
                                this.$set(this.items[index], 'frozen_h1', 0);
                                this.$set(this.items[index], 'frozen_saturday', 0);
                            }
                        } else {
                            // Initialize with default values if no closing data exists
                            if (this.items[index].sales_tomorrow === undefined) {
                                this.$set(this.items[index], 'sales_tomorrow', 0);
                            }
                            if (this.items[index].cautions === undefined) {
                                this.$set(this.items[index], 'cautions', 0);
                            }
                            if (this.items[index].new_arrival === undefined) {
                                this.$set(this.items[index], 'new_arrival', 0);
                            }
                            if (this.items[index].frozen === undefined) {
                                this.$set(this.items[index], 'frozen', 0);
                            }
                            
                            if (!this.outlet.is_inner_city) {
                                if (this.items[index].sales_today === undefined) {
                                    this.$set(this.items[index], 'sales_today', 0);
                                }
                                if (this.items[index].frozen_h1 === undefined) {
                                    this.$set(this.items[index], 'frozen_h1', 0);
                                }
                                if (this.items[index].frozen_saturday === undefined) {
                                    this.$set(this.items[index], 'frozen_saturday', 0);
                                }
                            } else {
                                this.$set(this.items[index], 'sales_today', 0);
                                this.$set(this.items[index], 'frozen_h1', 0);
                                this.$set(this.items[index], 'frozen_saturday', 0);
                            }
                        }
                    });
                }
            } catch (error) {
                console.warn('Error fetching closing outlet data:', error);
                // Don't throw error, just log warning - closing outlet data is optional
            }
        },
        calculateOpening(row, index) {
            if (row.is_past_day && !row.is_today) {
                return row.opening;
            } else {
                let opening =  this.calculateClosing(this.items[index - 1], index - 1);

                return opening;
            }
        },
        calculateTotal(row, index) {
            if (index > 0) {
                row.opening = this.calculateOpening(row, index);
            }

            let total = parseInt(row.opening) + parseInt(row.stock_in) + parseInt(row.stock_in_polim) +  parseInt(row.stock_in_cikupa) + parseInt(row.transfer_in) - parseInt(row.transfer_out);

            return total;
        },
        calculateClosing(row, index) {
            if (row && typeof row !== 'undefined') {
                if (row) {
                    if (row?.is_past_day && !row?.is_today) {
                        return row.closing;
                    } else {
                        let sisa = (parseInt(row?.opening) + parseInt(row?.stock_in) + parseInt(row?.stock_in_polim) + parseInt(row?.stock_in_cikupa) + parseInt(row?.transfer_in) - parseInt(row?.transfer_out)) - parseInt(row?.sales_planning) - parseInt(row?.return);
            
                        if (index < this.items.length - 1) {
                            this.items[index + 1].opening = sisa;
                        }
            
                        this.$set(this.items[index], 'closing', sisa);
            
                        return sisa;
                    }
                }
            } else {
                return 0;
            }
        },
        calculateSalesTargetTotal(row, items) {
            let result = 0;

            const filters = items.filter(i => i.idx >= row.idx);

            if (row.is_day === 1) {
                for (const rowFilter of filters) {
                    if (rowFilter.idx !== row.idx && rowFilter.is_day === 1) {
                        break;
                    }
                    result += parseInt(rowFilter.sales_target);
                }
            }

            return result;
        },
        calculateStatusBotol(row, items, index) {
            let result = 0;
            const closing = this.calculateClosing(row, index);

            let maxIndex = row.idx + parseInt(row.total_hari_status_botol);
            if (maxIndex > 14) {
                maxIndex = 14;
            }

            const filters = items.filter(i => i.idx >= row.idx && i.idx <= maxIndex);
            for (const rowFilter of filters) {
                result += parseInt(rowFilter.sales_planning);
            }

            return closing - result;
        },
        updateSalesTarget(row, value) {
            row.sales_planning = value;
            row.sales_target = value;
        },
        isDisableInput(row) {
            return row.is_past_day && !row.is_today;
        },
        isDisableInputStockIn(row) {
            return row.is_past_day && !row.is_today;
        },
        isWarning(row, index) {
            const sisa = this.calculateClosing(row, index);

            return sisa < row.min_stock || sisa > row.max_stock;
        },
        async saveDetailPlanning() {
            await this.$refs.detailPlanningForm.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            try {
                // Save detail planning first
                const result = await this.$store.dispatch('detailplanning/postObj', {
                    items: this.items
                });

                if (result.status == 200 || result.status == 201) {
                    // Save closing outlet data - integrated with detail planning
                    const closingSaveResult = await this.saveClosingOutletData();
                    
                    if (closingSaveResult && !closingSaveResult.success) {
                        // If closing outlet save failed, show warning but don't block success
                        console.warn('Detail planning saved but closing outlet update failed:', closingSaveResult.error);
                    }
                    
                    // this.$router.go(-1)
                    // this.$router.push(`/detail-planning`);
                    this.saved = true
                } else {
                    this.saveError = true
                }

                this.saveProgress = false
            } catch (error) {
                console.error('Error save detail planning:', error);
                this.saveError = true;
            } finally {
                this.saveProgress = false;
                this.showDialog = true;
            }  
            
        },
        /**
         * Save closing outlet data from detail planning items
         * This method extracts closing outlet fields from detail planning items
         * and saves them to closing outlet table
         * Called automatically when detail planning is saved to ensure data synchronization
         */
        async saveClosingOutletData() {
            try {
                const outletCode = this.$route.params.outlet_code;
                
                if (!outletCode || !this.selectedBottle || !this.selectedBottle.code) {
                    console.warn('Cannot save closing outlet: missing required data');
                    return { success: false, error: 'Missing required data' };
                }
                
                // Prepare closing outlet items from detail planning items
                // Only include items that have valid sales_date
                const closingItems = this.items
                    .filter(item => item.sales_date) // Filter out items without date
                    .map(item => {
                        const closingItem = {
                            outlet_code: outletCode,
                            closing_date: moment(item.sales_date).format('YYYY-MM-DD'),
                            volume: this.selectedBottle.code,
                            sales_tomorrow: parseInt(item.sales_tomorrow) || 0,
                            cautions: parseInt(item.cautions) || 0,
                            new_arrival: parseInt(item.new_arrival) || 0,
                            frozen: parseInt(item.frozen) || 0,
                        };

                        // For outer city outlets, include additional fields
                        if (!this.outlet.is_inner_city) {
                            closingItem.sales_today = parseInt(item.sales_today) || 0;
                            closingItem.frozen_h1 = parseInt(item.frozen_h1) || 0;
                            closingItem.frozen_saturday = parseInt(item.frozen_saturday) || 0;
                        } else {
                            // For inner city, set to 0 if not applicable
                            closingItem.sales_today = 0;
                            closingItem.frozen_h1 = 0;
                            closingItem.frozen_saturday = 0;
                        }

                        return closingItem;
                    });

                if (closingItems.length === 0) {
                    console.warn('No valid closing items to save');
                    return { success: false, error: 'No valid items to save' };
                }

                // Save to closing outlet using updateOrCreate (postObj handles this)
                const response = await this.$store.dispatch('outletclosing/postObj', {
                    items: closingItems
                });

                if (response.data && response.data.status === 'success') {
                    console.log('Closing outlet data saved successfully');
                    return { success: true };
                } else {
                    console.warn('Closing outlet save returned non-success status:', response.data);
                    return { success: false, error: response.data?.message || 'Unknown error' };
                }
            } catch (error) {
                console.error('Error saving closing outlet data:', error);
                return { 
                    success: false, 
                    error: error.response?.data?.message || error.message || 'Failed to save closing outlet data' 
                };
            }
        },
        async updateStatusOutlet(status) {
            const outletCode = this.$route.params.outlet_code;

            const result = await this.$store.dispatch('outlet/updateStatus', {payload: { detail_planning_status: status }, outlet_code: outletCode});
            if (result.status == 200) {
                this.saved = true
            } else {
                this.saveError = true
            }
        },
        async BackToOutlet() {
            const outletCode = this.$route.params.outlet_code;

            const result = await this.$store.dispatch('outlet/updateStatus', {payload: { detail_planning_status: 'open' }, outlet_code: outletCode});
            if (result.status == 200) {
                this.$router.push(`/detail-planning`);
            } 
        },
        refreshData() {
            this.fetchDetailPlanning();
        },
        handleShowNote(item) {
            this.noteTitle = `: ${item.day_name}, ${item.sales_date_format}`;
            this.noteIndex = item.idx;
            this.updatedNote = item.notes;

            this.dialogNote = true;
        },
        saveNote() {
            this.items[this.noteIndex].notes = this.updatedNote;

            this.noteIndex = '';
            this.updatedNote = '';

            this.dialogNote = false;
        },
        async handleBackButton() {
            const outletCode = this.outlet.code;

            await this.$store.dispatch('outlet/updateStatus', {payload: { detail_planning_status: 'open' }, outlet_code: outletCode});

            window.removeEventListener("popstate", this.confirmBack);
            this.$router.push({ name: "Detail Planning" });
        },

        clickCalculateColumn() {
            this.isShowSquareCol = !this.isShowSquareCol;
            if (!this.isShowSquareCol) {
                this.clearSquareItems();
            }
        },

        toggleItem(id, value) {
            const index = this.selectedSquareItems.findIndex(item => item.id === id);
            if (index > -1) {
                this.selectedSquareItems.splice(index, 1);
            } else {
                this.selectedSquareItems.push({ id, value});
            }
        },
        clearSquareItems() {
            this.selectedSquareItems = [];
        }
    },
}
</script>

<style scoped>
.no-padding-table td {
    padding: 0 !important;
    margin: 0 !important;
}
td .v-text-field {
    width: 100%;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

.text-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.text-input .v-input__slot {
    background-color: #ffe169 !important;
    text-align: center;
}


.warning-input input {
  padding: 0 !important;
  border: none;
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__control {
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__slot {
  background-color: #FBDADE !important;
}

.warning-input ::v-deep .v-input__control input {
  background-color: #FBDADE !important;
  text-align: center;
}

.warning-input .v-input__slot {
    background-color: #FBDADE !important;
    text-align: center;
}

.custom-center-input ::v-deep .v-input__control input {
  text-align: center;
}

.custom-center-input .v-input__slot {
    text-align: center;
}

/* Enable horizontal scrolling for the table */
.freeze-column-table .v-data-table__wrapper {
  overflow-x: auto;
}

/* Sticky first column */
.freeze-column-table th:nth-child(1),
.freeze-column-table td:nth-child(1) {
  position: sticky;
  left: 0;
  background-color: #fff; /* Match table background */
  z-index: 3; /* Higher than other rows */
  border-right: 1px solid #ddd; /* Optional border */
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

.blue-light-input input {
  padding: 0 !important;
  border: none;
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__control {
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__slot {
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__control input {
  background-color: #bde0fe !important;
}

.blue-light-input .v-input__slot {
    background-color: #bde0fe !important;
}

.blue-light-input input {
  padding: 0 !important;
  border: none;
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__control {
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__slot {
  background-color: #bde0fe !important;
}

.blue-light-input ::v-deep .v-input__control input {
  background-color: #bde0fe !important;
}

.blue-light-input .v-input__slot {
    background-color: #bde0fe !important;
}

.red-input input {
  padding: 0 !important;
  border: none;
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__control {
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__slot {
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__control input {
  background-color: #FF7F7F !important;
}

.red-input .v-input__slot {
    background-color: #FF7F7F !important;
}

.red-input input {
  padding: 0 !important;
  border: none;
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__control {
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__slot {
  background-color: #FF7F7F !important;
}

.red-input ::v-deep .v-input__control input {
  background-color: #FF7F7F !important;
}

.red-input .v-input__slot {
    background-color: #FF7F7F !important;
}

/* Chrome, Safari, Edge, Opera */
::v-deep input[type=number]::-webkit-inner-spin-button, 
::v-deep input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
::v-deep input[type=number] {
  -moz-appearance: textfield;
}

</style>

<style>

</style>